import { Fragment, useState } from "react";
import { Table } from "reactstrap";
import { DetailedAlert } from "../../../components/DetailedAlert";
import { Toolbar } from "../../../components/Toolbar";
import { AdministrateResourceDeleteButton } from "../../components/AdministrateResourceDeleteButton";
import { AdministrateToggle } from "../../components/AdministrateToggle";
import { useUpdatePermission } from "../../utils";
import { AddS3DirectoryModal } from "./AddS3DirectoryModal";
import { EditS3DirectoryModal } from "./EditS3DirectoryModal";
import { extractErrorMessage } from "../../../util/api";

export const S3Settings = ({ resource, resourcePath, refresh, tabName, tab_key, showDocumentIngestion }) => {
  const [message, setMessage] = useState(null);
  const [canUpdate] = useUpdatePermission("S3Directory");

  const onAction = (results) => {
    window.localStorage.setItem(tab_key, tabName);
    setMessage(results.meta.message);
    refresh();
  };

  return (
    <>
      {canUpdate && (
        <Toolbar className="align-items-center mb-3">
          <Toolbar className="ms-auto">
            <AddS3DirectoryModal resourcePath={resourcePath} onAdd={onAction} showDocumentIngestion={showDocumentIngestion} />
          </Toolbar>
        </Toolbar>
      )}

      {message && <DetailedAlert message={message} messageStyle="info" alertLinkClass="alert-link ms-2" />}

      <Table>
        <thead>
          <tr>
            <th>Bucket Name</th>
            <th>Prefix</th>
            <th>Sweep Enabled</th>
            <th>Tilde Delimited File</th>
            <th>Keep File in Directory</th>
            {showDocumentIngestion && <th>Document Ingestion</th>}
            <th>Has External Role?</th>
            {canUpdate && <th>Action</th>}
          </tr>
        </thead>
        <tbody>
          {resource.s3Directories?.map((s3Directory) => {
            return (
              <Fragment key={s3Directory.id}>
                <tr>
                  <td>{s3Directory.bucket_name}</td>
                  <td>{s3Directory.prefix}</td>
                  <td>
                    <AdministrateToggle
                      id={`s3-toggle-${s3Directory.id}`}
                      toggle={s3Directory.enabled}
                      endpoint={`${resourcePath}/s3_directories/${s3Directory.id}`}
                      params={(toggle) => {
                        return { s3Directory: { id: s3Directory.id, enabled: toggle } };
                      }}
                      onChange={setMessage}
                      onError={setMessage}
                      disabled={!canUpdate}
                    />
                  </td>
                  <td>
                    <AdministrateToggle
                      id={`s3-tilde-toggle-${s3Directory.id}`}
                      toggle={s3Directory.tilde_delimited_file}
                      endpoint={`${resourcePath}/s3_directories/${s3Directory.id}`}
                      params={(toggle) => {
                        return { s3Directory: { id: s3Directory.id, tilde_delimited_file: toggle } };
                      }}
                      onChange={setMessage}
                      onError={setMessage}
                      disabled={!canUpdate}
                    />
                  </td>
                  <td>
                    <AdministrateToggle
                      id={`s3-keep-file-toggle-${s3Directory.id}`}
                      toggle={s3Directory.keep_file_in_directory}
                      endpoint={`${resourcePath}/s3_directories/${s3Directory.id}`}
                      params={(toggle) => {
                        return { s3Directory: { id: s3Directory.id, keep_file_in_directory: toggle } };
                      }}
                      onChange={setMessage}
                      onError={setMessage}
                      disabled={!canUpdate}
                    />
                  </td>
                  {showDocumentIngestion && (
                    <td>
                      <AdministrateToggle
                        id={`s3-document-ingestion-toggle-${s3Directory.id}`}
                        toggle={s3Directory.is_document_ingestion}
                        endpoint={`${resourcePath}/s3_directories/${s3Directory.id}`}
                        params={(toggle) => {
                          return { s3Directory: { id: s3Directory.id, is_document_ingestion: toggle } };
                        }}
                        onChange={setMessage}
                        onError={setMessage}
                        disabled={!canUpdate}
                      />
                    </td>
                  )}
                  <td>{s3Directory.role_arn ? "Yes" : "No"}</td>
                  {canUpdate && (
                    <td>
                      <EditS3DirectoryModal
                        resourcePath={resourcePath}
                        onEdit={onAction}
                        s3Directory={s3Directory}
                        showDocumentIngestion={showDocumentIngestion}
                      />
                      <AdministrateResourceDeleteButton
                        deleteUrl={`${resourcePath}/s3_directories/${s3Directory.id}`}
                        onError={(err) => setMessage(extractErrorMessage(err))}
                        onSuccess={(results) => {
                          window.localStorage.setItem(tab_key, tabName);
                          setMessage(`Successfully removed S3 directory ${s3Directory.bucket_name}/${s3Directory.prefix}`);
                          refresh();
                        }}
                      />
                    </td>
                  )}
                </tr>
              </Fragment>
            );
          })}
        </tbody>
      </Table>
    </>
  );
};
